<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-title align-items-start flex-column">
        <span class="font-weight-bolder text-dark">Merge Contacts</span>
        <!--        <span class="text-muted mt-3 font-weight-bold font-size-sm">{{getContactTitle()}}</span>-->
      </h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="mergeForm">
    <div class="card-body">
      <div class="form-group">
        <div class="row">
          <div class="col kt-margin-bottom-20-mobile">
            <kt-general-autocomplete
              [appearance]="'fill'"
              [label]="'Contacts'"
              [loadItemsFunction]="contactAutocompleteCall"
              [optionFormatter]="stringUtils.autocompleteEntityFormatter"
              [valueFormatter]="stringUtils.autocompleteEntityFormatter"
              [required]="true"
              [readOnly]="false"
              [control]="mergeForm.get('contacts')"
              [change]="onContactChange.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Search for contact...'"
              [chipList]="true"
              [objects]="mergeForm.get('contacts').value"
              [formatNewObjectFn]="formatFn"
              #contactAutocomplete
            ></kt-general-autocomplete>
          </div>
        </div>
      </div>
      <div class="merge-cue">
        <div class="merge-row merge-header">
          <span class="merge-col">Merge Into</span>
          <span class="merge-col">Contact</span>
        </div>
        <div
          *ngIf="!contactAutocomplete.value?.length; else selectedContacts"
          class="d-flex flex-center font-weight-bold p-5"
        >
          No contacts selected for merge!
        </div>
        <ng-template #selectedContacts>
          <div class="merge-row">
            <span class="merge-col"
              ><span class="flaticon2-accept icon-md text-success"></span
            ></span>
            <span class="merge-col">{{ getFullName(data) }} ({{ data.id }})</span>
          </div>
          <div *ngFor="let contact of contactAutocomplete.value" class="merge-row">
            <span class="merge-col"><span class="flaticon2-accept icon-md text-muted"></span></span>
            <span class="merge-col">{{ getFullName(contact) }} ({{ contact.id }})</span>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            (click)="onCloseClick()"
            type="button"
            mat-raised-button
            cdkFocusInitial
            matTooltip="Cancel"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <ng-template ngxPermissionsOnly="canEditTask">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="onMergeClick()"
              matTooltip="Merge"
            >
              Merge
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </form>
</div>
